export default __webpack_public_path__ + "static/media/attraction-icon.b671327e.svg";